{
  "selectAsField": "選擇「{value}」作為{fieldName}",
  "typeToSearchField": "輸入以搜尋{fieldName}",
  "licenseFieldLabel": "選擇車牌號碼（例如 215BG2）",
  "licenseFieldName": "車牌號碼",
  "licensePlaceholder": "依車牌號碼搜尋",
  "dotFieldLabel": "選擇 DOT 編號",
  "dotFieldName": "DOT 編號",
  "dotPlaceholder": "依 DOT 編號搜尋"
}
